// extracted by mini-css-extract-plugin
export default {"column":"Column_column__T6TRe","items":"Column_items__ogAF+","active":"Column_active__7EQ-s"};